export const mfCarregandoEvento = {
    EXIBIR_CARREGANDO: 'mf.carregando:exibir_carregando',
    ESCONDER_CARREGANDO: 'mf.carregando:esconder_carregando'
}